module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"enter-number":"Вернуться к вводу номера","enter-sms-code":"Ввести sms код","enter-email-code":"Ввести email код","enter-password":"Ввести пароль","registration":"Вернуться к регистрации","profile":"Профиль","success":"Успех!"}}')
  delete Component.options._Ctor
}
